import { render } from "./Whitelist.vue?vue&type=template&id=76fc1c30&scoped=true"
import script from "./Whitelist.vue?vue&type=script&lang=js"
export * from "./Whitelist.vue?vue&type=script&lang=js"

import "./Whitelist.vue?vue&type=style&index=0&id=76fc1c30&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fc1c30"]])

export default __exports__